module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/49_Vintage Wash Bomber Jacket.png";